import React, { Component } from 'react';
import PlanShape from '../Models/PlanShape'
import Config from '../Configs/staticConfig'


class Maps extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            isMapLoaded: false,
        };

        this.loadMap = this.loadMap.bind(this);
        this.onMapLoaded = this.onMapLoaded.bind(this);
        this.switchMapTypes = this.switchMapTypes.bind(this);
        this.navigateToPlan = this.navigateToPlan.bind(this);
        this.initListener = this.initListener.bind(this)
        this.removeListener = this.removeListener.bind(this)

        this.mapsBreakpointSmall = 960;
    }

    componentDidMount() {
        this.loadMap();
    }

    componentDidUpdate() {
        this.switchMapTypes();
    }
    
    componentWillReceiveProps(nextProps){
        if(this.state.isMapLoaded !== false){
            this.removeListener()
            this.initListener(nextProps)
        }
    }

    loadMap() {
        if ( window.mapRef === undefined ) {
            window.onMapLoaded = this.onMapLoaded;
            loadMapJS(`https://maps.googleapis.com/maps/api/js?libraries=geometry,drawing&key=${Config.getMapKey()}&callback=onMapLoaded`);
        }
        else {
            this.onMapLoaded();
        }
    }

    onMapLoaded() {
        window.mapRef = new window.google.maps.Map(document.getElementById('MapView'), {
            center: {lat: 13.764897, lng: 100.538123},
            zoom: 16,
            disableDefaultUI: true,   
            rotateControl: true,      
            mapTypeId: 'satellite',
            gestureHandling: 'greedy'
        })

        window.drawingManager = new window.google.maps.drawing.DrawingManager({
            drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
            drawingControl: false
        })

        this.initListener(this.props)

        this.setState({
            isMapLoaded: true
        });
    }

    findMyLocation() {
        if ( navigator.geolocation === undefined || window.mapRef === undefined ) {
            alert('Geolocation is not supported by this browser.');
            return;
        }
        navigator.geolocation.getCurrentPosition(position => {
            var coord = {
                lat: position.coords.latitude, 
                lng: position.coords.longitude
            }
            var userMarker;
            var color = '#FAFAFA';
            if ( window.mapRef.getMapTypeId() === 'roadmap' ){
                color = '#000000';
            }
            else {
                color = '#FAFAFA';
            }
        
            window.setTimeout(() => {
                userMarker = new window.google.maps.Marker({
                    position: coord,
                    map: window.mapRef,
                    animation: window.google.maps.Animation.DROP,
                    label: {
                        text: 'ตำแหน่งของคุณ',
                        color: color
                    }
                });
            }, 500);
            
            window.setTimeout(() => {
                userMarker.setMap(null);
            }, 3000);

            window.mapRef.panTo(coord);
        }, err => {
            console.log(err);
            if ( err.code === err.PERMISSION_DENIED ) alert('User denied the request for Geolocation.');
        }, {
            timeout: 30000, 
            enableHighAccuracy: true, 
            maximumAge: 75000
        });
    }

    switchMapTypes() {
        const { mapType } = this.props;
        if ( window.mapRef === undefined ) return;
        if ( window.mapRef.getMapTypeId() === mapType ) return;
        switch( mapType ) {
            case 'roadmap':   
                window.mapRef.setMapTypeId('roadmap');                             
                break;

            default:
                window.mapRef.setMapTypeId('satellite'); 
                break;

        }
    }

    navigateToPlan(plan) {
        if ( window.mapRef === undefined || plan === undefined || plan === null ) return;
        var paddings = {
            top: 96,
            right: 64,
            bottom: 96,
            left: 64
        };
        if ( window.innerWidth <= this.mapsBreakpointSmall ) {
            paddings.bottom = 130;
        }
        else {
            paddings.left = 396;
        }
        if ( plan.planBounds() !== null ) {
            window.mapRef.fitBounds(plan.planBounds(), paddings);
        }
    }

    navigateToDroneLayer(droneLayer) {
        if ( window.mapRef === undefined || droneLayer === undefined || droneLayer === null ) return;
        var paddings = {
            top: 96,
            right: 64,
            bottom: 96,
            left: 64
        };
        if ( window.innerWidth <= this.mapsBreakpointSmall ) {
            paddings.bottom = 130;
        }
        else {
            paddings.left = 396;
        }
        if ( droneLayer.bounds() !== null ) {
            window.mapRef.fitBounds(droneLayer.bounds(), paddings);
        }
    }

    initListener(props){
        const { setCurrentPlan ,currentPlan, setSelectedShape } = props
        
        window.google.maps.event.addListener(window.drawingManager, 'overlaycomplete', function (overlay) {            
            var shape = new PlanShape()
            shape.type = overlay.type
            if(overlay.type === 'marker'){
                shape.coordsArray.push({lat:overlay.overlay.position.lat(),lng:overlay.overlay.position.lng()})
            }
            else{
                overlay.overlay.latLngs.j[0].j.forEach(latlng => {
                    shape.coordsArray.push({lat:latlng.lat(),lng:latlng.lng()})
                })
            }
            
            pushShapeToPlan.call(this,shape)
            overlay.overlay.setMap(null)
        })

        window.google.maps.event.addListener(window.drawingManager,'click',function(e){
            console.log(e)
        })
            
        function pushShapeToPlan(shape){
            currentPlan.shapesArray.push(shape)
            setSelectedShape([shape])
            setCurrentPlan(currentPlan)
        }
    }

    removeListener(){
        window.google.maps.event.clearInstanceListeners(window.drawingManager)
    }

    render() {
        const { isMapLoaded } = this.state;
        var childrenElements = null;
        if ( isMapLoaded === true ) {
            childrenElements = this.props.children;
        }
        
        return (
            <div className="MapsView">
                <div className="MapView" id="MapView">
                    {childrenElements}
                </div>
            </div>
        );
    }

}

function loadMapJS(src) {
    var ref = window.document.getElementsByTagName("script")[0];
    var script = window.document.createElement("script");
    script.src = src;
    script.async = true;
    script.defer = true
    ref.parentNode.insertBefore(script, ref);
}
export default Maps;


// WEBPACK FOOTER //
// ./src/PageMaps/_Maps.js